// extracted by mini-css-extract-plugin
export default {"imageContainer":"style_imageContainer__pPbv4","image":"style_image__42EX5"};